import { ThunkAction } from "redux-thunk";
import { Action as ReduxAction } from "redux";
import { SubmitFeatureRequest } from "../Models/SubmitFeatureRequest";
import { SubmitBugReport } from "../Models/SubmitBugReport";
import { IAppState, ApiRequest } from "../../Common";
import { Application } from "../../App/Models/Application";
import { endpoints } from "../../App";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import ResponseHandler from "../../App/ResponseHandler";
import { SubmitResourceRequest } from "../Models/SubmitResourceRequest";

export interface ActionBase {
  type: FeedbackFormActionType;
}

export interface Action<Payload> extends ActionBase {
  payload: Payload;
}

export enum FeedbackFormActionType {
  UPDATE_FEATURE_REQUEST = "FEEDBACK_CREATE_UPDATE_FEATURE_REQUEST",
  UPDATE_BUG_REPORT = "FEEDBACK_CREATE_UPDATE_BUG_REPORT",
  UPDATE_RESOURCE_REQUEST = "FEEDBACK_CREATE_UPDATE_RESOURCE_REQUEST",
  SET_ACTIVE_TAB = "FEEDBACK_CREATE_SET_ACTIVE_TAB",
  SET_APPLICATIONS = "FEEDBACK_CREATE_SET_APPLICATIONS",
  RESET_ERROR = "FEEDBACK_CREATE_RESET_ERROR",
  SET_ERROR = "FEEDBACK_CREATE_SET_ERROR",
  SET_LOADING = "FEEDBACK_CREATE_SET_LOADING",
  RESET_LOADING = "FEEDBACK_CREATE_RESET_LOADING",
  RESET_LOADED = "FEEDBACK_CREATE_RESET_LOADED"
}

export const updateFeatureRequest = (
  featureRequest: SubmitFeatureRequest
): Action<SubmitFeatureRequest> => {
  return {
    type: FeedbackFormActionType.UPDATE_FEATURE_REQUEST,
    payload: featureRequest
  };
};

export const updateBugReport = (bugReport: SubmitBugReport): Action<SubmitBugReport> => {
  return {
    type: FeedbackFormActionType.UPDATE_BUG_REPORT,
    payload: bugReport
  };
};

export const updateResourceRequest = (
  resourceRequest: SubmitResourceRequest
): Action<SubmitResourceRequest> => {
  return {
    type: FeedbackFormActionType.UPDATE_RESOURCE_REQUEST,
    payload: resourceRequest
  };
};
